import React, { useRef, useEffect } from 'react';
import SimpleTable, { ButtonsExportar } from '../../../../core/components/simpleTables/SimpleTable';
import tableStyles from './Tables.module.scss';
import historicoSituacoesIndicadorService from '../../../../service/HistoricoSituacoesIndicadorService';
import { inputsHistoricoSituacoes } from '../PageInputs';
import { Column } from 'primereact/column';
import { useParams } from 'react-router-dom';

function HistoricoSituacoes() {
    const tableRef = useRef(null);
    const { id } = useParams();

    useEffect(() => {
        tableRef.current?.onFiltro({ indicador: { id } });
    }, []);

    return (
        <div>
            <SimpleTable
                ref={tableRef}
                onFind={historicoSituacoesIndicadorService.pesquisar.bind(
                    historicoSituacoesIndicadorService
                )}
                header={
                    <div className={tableStyles.containerExportButtons}>
                        <ButtonsExportar
                            onExportar={(tipo) =>
                                historicoSituacoesIndicadorService.exportaDataToFile(tipo, {
                                    search: `indicador.id==${id}`,
                                })
                            }
                        />
                    </div>
                }
            >
                {inputsHistoricoSituacoes.map((el, index) => (
                    <Column key={index} field={el?.name} header={el?.label} />
                ))}
            </SimpleTable>
        </div>
    );
}

export default HistoricoSituacoes;
